import ChatScreen from 'views/chatScreen/ChatScreen.container';

export default ChatScreen;
